export type AccountSummaryRow = {
  valueUsd: number
  loading: boolean
  loadError: boolean
}

export type AccountSummary = {
  totalValueUsd: number
  totalValueLoading: boolean
  isFunded: boolean
}

export function buildAccountSummary(rows: AccountSummaryRow[]): AccountSummary {
  const totalValueUsd = rows.reduce((total, row) => total + row.valueUsd, 0)
  const totalValueLoading = rows.some((row) => row.loading)
  const hasAnyLoadError = rows.some((row) => row.loadError)

  return {
    totalValueUsd,
    totalValueLoading,
    isFunded:
      totalValueLoading ||
      hasAnyLoadError ||
      rows.some((row) => row.valueUsd > 0),
  }
}
